import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface IDocumentTemplateCategoryEditorViewProps {
    value: number | null;
    onChange: (value: IDocumentTemplateCategorySummary | null) => void;
    request: DropdownRequest<IDocumentTemplateCategorySummary>;
    mode: ControlMode;
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class DocumentTemplateCategoryEditorView extends React.Component<IDocumentTemplateCategoryEditorViewProps, any> {
    constructor(props: IDocumentTemplateCategoryEditorViewProps) {
        super(props);
    }

    render() {
        return (
            <DropdownView
                model={this.props.value}
                onChanged={this.props.onChange}
                request={this.props.request}
                required={this.props.required}
                onGetErrorMessage={this.props.onGetErrorMessage}
                label={this.props.label}
                disabled={this.props.mode == 'display'}
                keyField='id'
                textField='displayName'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-categories/parts/document-template-category-editor.view.tsx